/**
 * @prettier
 * @flow
 */
// let language = ((navigator: any).userLanguage || (navigator.languages && navigator.languages.length && navigator.languages[0]) || navigator.language || (navigator: any).browserLanguage || (navigator: any).systemLanguage || 'en').substring(0, 2);
let language = 'es-MX';

export function setLanguage(value: any) {
    language = value;
}

export function getLanguage() {
    return language;
}
